import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  align?: "left" | "center";
  tone?: "dark" | "light";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "dark",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}`}>
      {eyebrow && (
        <p
          className={`font-label text-xs font-semibold tracking-[0.28em] ${
            tone === "dark" ? "text-primary-600" : "text-primary-200"
          }`}
        >
          {eyebrow}
        </p>
      )}
      <h2
        className={`mt-3 font-heading text-3xl leading-tight md:text-4xl ${
          tone === "dark" ? "text-foreground-950" : "text-background-50"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-4 text-sm leading-relaxed md:text-base ${
            tone === "dark" ? "text-foreground-600" : "text-background-100/80"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}